import { callApi } from "./fetchTools";
import { HTTP_METHOD_POST, HTTP_METHOD_GET } from "../utils/constant";
import apis from "../common/apis";
import { IResponse } from "./../models/base";

export default {
  authSignIn: (query: any) => {
    return callApi<IResponse<any>>(HTTP_METHOD_POST, apis.user_signin, query);
  },
  authSignUp: (query: any) => {
    return callApi<IResponse<any>>(HTTP_METHOD_POST, apis.user_signup, query);
  },
  authConfirmOTP: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_POST,
      apis.user_confirm_otp_code,
      query
    );
  },
  authResendOTP: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_POST,
      apis.user_resend_otp_code,
      query
    );
  },
  authForgotPassword: (query: any) => {
    return callApi<IResponse<any>>(
      HTTP_METHOD_POST,
      apis.user_forgot_password,
      query
    );
  },
  authSignOut: () => {
    return callApi<IResponse<any>>(HTTP_METHOD_GET, apis.user_signout, null);
  },
};
